import { IconButton, Stack, Tooltip } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteIcon from "src/assets/svg-icons/aggregators/delete.svg";
import { useDeleteCogsMutation } from "src/api/settings/cogs";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { useTranslation } from "react-i18next";
import DownloadIcon from "src/assets/svg-icons/download.svg";
import COGSAttachmentsPopup from "../../attachments-popup";
import { specificBranchHasPermission } from "src/utils";
import { InventoryPermissions } from "src/constants/permissions";

const TableActions = ({
  rowId,
  reference,
  refetch,
  branchId,
}: {
  rowId: number;
  reference: string;
  refetch: Function;
  branchId: number;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation("general");
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const { mutate, isPending, status, error } = useDeleteCogsMutation();
  const [openAttachmentsModal, setOpenAttachmentsModal] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // permissions
  const deletePermission = specificBranchHasPermission(
    InventoryPermissions.deleteCogs,
    branchId
  );

  const handleOpenAttachmentsModal = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setOpenAttachmentsModal(true);
  };

  const handleCloseAttachmentsModal = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setOpenAttachmentsModal(false);
  };

  const handleDelete = () => {
    mutate(rowId);
  };

  const navigateToViewPage = () => {
    navigate(`/inventory/cogs/${rowId}/edit`);
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleClose();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: t("deletedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || t("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack
      direction={"row"}
      spacing={"12px"}
      width={"100%"}
      justifyContent={"center"}
    >
      <IconButton onClick={handleOpenAttachmentsModal}>
        <img src={DownloadIcon} alt="" />
      </IconButton>
      <Tooltip title={t("details")}>
        <IconButton onClick={navigateToViewPage}>
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {deletePermission && (
        <IconButton onClick={handleOpen}>
          <img src={DeleteIcon} alt="" />
        </IconButton>
      )}

      <ConfirmPopup
        open={open}
        item={reference}
        handleClose={handleClose}
        handleConfirm={handleDelete}
        isPending={isPending}
      />

      {/* attachments popup */}
      {openAttachmentsModal && (
        <COGSAttachmentsPopup
          open={openAttachmentsModal}
          handleClose={handleCloseAttachmentsModal}
          rowId={rowId}
        />
      )}
    </Stack>
  );
};
export default TableActions;
